export const EXPERIENCE_ES = [
  {
    year: 'Ene 2025 — Presente',
    role: 'FullStack Developer',
    co: 'Dlocs',
    desc: 'Lideré el ciclo de vida completo de 2 aplicaciones Full Stack con PHP/Laravel, Tailwind CSS, Livewire y Alpine.js. Integré pasarelas de pago, correos transaccionales y microservicios de reportes PDF asíncronos. Optimicé bases de datos en SQL Server y creé un pipeline de CI/CD sobre Linux, NGINX y Azure (Dev, QA y Preproducción).',
  },
  {
    year: 'Jul 2025 — Jun 2026',
    role: 'FullStack Developer · Part Time',
    co: 'Atiempo',
    desc: 'Desarrollé 5 aplicaciones en producción (2 con React Native, 1 con Ionic/Angular y 2 con Next.js) usadas en más de 4 países, con SSR/SSG para mejorar SEO y velocidad. Implementé tiempo real con WebSockets, suscripciones con Stripe y webhooks, y un módulo de videollamadas y chat con WebRTC.',
  },
  {
    year: 'Ene 2024 — Nov 2024',
    role: 'Frontend Developer',
    co: 'Nexo-it Consultores SpA',
    desc: 'Lideré la migración y modernización de 2 apps móviles en React Native, mejorando el rendimiento un 40%. Implementé pruebas unitarias e integradas con Jest y React Testing Library aplicando TDD, y optimicé el estado global y la caché para soporte offline.',
  },
  {
    year: 'Jul 2022 — Sep 2023',
    role: 'Frontend Developer',
    co: 'Prolesys Consultores C.A.',
    desc: 'Desarrollé y mantuve 4 aplicaciones web críticas de alta disponibilidad con millones de usuarios activos. Diseñé un sistema de componentes reutilizables que estandarizó la UI/UX y redujo los tiempos de entrega, trabajando bajo Scrum.',
  },
  {
    year: 'Sep 2021 — Jul 2022',
    role: 'FullStack Developer',
    co: 'Fibex Telecom',
    desc: 'Contribuí a 5 plataformas en producción para web, móviles, tablets y Smart TVs. Lideré de extremo a extremo una app de geolocalización con React en el frontend y Node.js, Express y TypeScript en el backend.',
  },
];

export const EXPERIENCE = [
  {
    year: 'Jan 2025 — Now',
    role: 'FullStack Developer',
    co: 'Dlocs',
    desc: 'Led the full lifecycle of 2 Full Stack applications with PHP/Laravel, Tailwind CSS, Livewire and Alpine.js. Integrated payment gateways, transactional emails and asynchronous PDF report microservices. Optimized SQL Server databases and built a CI/CD pipeline on Linux, NGINX and Azure (Dev, QA and Pre-production).',
  },
  {
    year: 'Jul 2025 — Jun 2026',
    role: 'FullStack Developer · Part Time',
    co: 'Atiempo',
    desc: 'Built 5 production applications (2 with React Native, 1 with Ionic/Angular and 2 with Next.js) used in over 4 countries, with SSR/SSG to improve SEO and load speed. Implemented real-time features with WebSockets, Stripe subscriptions and webhooks, and a video call and chat module with WebRTC.',
  },
  {
    year: 'Jan 2024 — Nov 2024',
    role: 'Frontend Developer',
    co: 'Nexo-it Consultores SpA',
    desc: 'Led the migration and modernization of 2 React Native mobile apps, improving performance by 40%. Implemented unit and integration tests with Jest and React Testing Library using TDD, and optimized global state and caching for offline support.',
  },
  {
    year: 'Jul 2022 — Sep 2023',
    role: 'Frontend Developer',
    co: 'Prolesys Consultores C.A.',
    desc: 'Built and maintained 4 mission-critical, high-availability web applications serving millions of active users. Designed a reusable component system that standardized UI/UX and shortened delivery times, working under Scrum.',
  },
  {
    year: 'Sep 2021 — Jul 2022',
    role: 'FullStack Developer',
    co: 'Fibex Telecom',
    desc: 'Contributed to 5 production platforms for web, mobile, tablets and Smart TVs. Led end to end a geolocation app with React on the frontend and Node.js, Express and TypeScript on the backend.',
  },
];